import { Component, Input } from '@angular/core';
import { SalesAgent } from '../../models/sales-agent.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sales-id-card',
  imports: [
    CommonModule
  ],
  templateUrl: './sales-id-card.html',
  styleUrl: './sales-id-card.scss',
})
export class SalesIdCard {
  @Input() agent!: SalesAgent;
}
